<template>
  <div class="OrderService">
    <ld-header fixed>
      免责声明
    </ld-header>

    <mescroll-vue
      ref="mescroll"
      :down="down"
    >
      <div class="content">
        <pre
          class="pre-wrap gray"
          v-html="content"
          style="padding: 8px;"
        />
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
export default {
  name: 'OrderService',
  components: {
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data () {
    return {
      down:{ use: false },
      content: ''
    }
  },
  created () {
    this.getRule()
  },
  methods: {
    getRule () {
      this.$api['common/getParListByCodes']({codes: 3202}).then(res => {
        this.content = res.data && res.data[0].value1
      })
    }
  }
}
</script>

<style lang="less" scoped>
.OrderService {
  height: 100vh;
  overflow: hidden;

  .content {
    margin-top: 66px;
  }
  
}
</style>